export const PAGINATION: any = {
  SIZE_OPTIONS: [10, 20, 30],
};
